module.exports = __webpack_public_path__ + "img/img2.f011d55e.png";